import React, { Component } from 'react'
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import { fetchSubscriptions, updateSubscription } from '../../../../Redux/Actions/Admin/ManageSubscriptionActions';
import { fetchStates, checkAddressCall } from '../../../../Redux/Actions/CommonActions'
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';

class AddressValidationTest extends Component {
    constructor(props) {
		super(props);
		this.state = {
            subscriptionInEdit: {},
		};
    }

    componentDidMount() {
        this.props.fetchStates();
        this.props.fetchSubscriptions();
    }
    
    componentDidUpdate() {
        if(this.props.subscription !== undefined && !this.state.hasProcessed) {
            this.setState({ hasProcessed: true })
			this.setState({ subscriptionInEdit: this.props.subscription})
		}
    }

    handleSubmit = (event) => {
        event.preventDefault();
		this.props.updateSubscription(this.state.subscriptionInEdit);
	};
/*
    cancel = () => {
		this.setState({});
	};*/

    onDialogInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

        const edited = this.state.subscriptionInEdit;
        
        edited[name] = value;

		this.setState({
			subscriptionInEdit: edited,
        });
    };

	handleState = (event) => {
		const value = event.target.value;
		if (value !== null) {
            this.setState({ 
                subscriptionInEdit: { ...this.state.subscriptionInEdit, state: value },
            })
        }
	};

	cancel = () => {
		this.setState({ subscriptionInEdit: {} });
	};

    render() {
        return (
            <Dialog onClose={this.cancel}>
                {this.props.common.visible ? (
					<Alert
						color={this.props.common.color}
						isOpen={this.props.common.visible}
						style={{ subscription: 'fixed', width: '100%' }}
					>
						{this.props.common.message}
					</Alert>
				    ) : null}
                <h2>Address Validation Testing</h2>
                <form onSubmit={this.handleSubmit}>
                    <div>
                        <label>
                        Preferred Mailing Name<br />
                            <Input
                                type="text"
                                name="preferredMailingName"
                                value={this.state.subscriptionInEdit.preferredMailingName || ''}
                                onChange={this.onDialogInputChange}
                            />
                        </label>
                    </div>
					<div>
						<label>
                        Billing Address 1<br />
							<Input
								type="text"
								name="billingAddress1"
								value={this.state.subscriptionInEdit.billingAddress1 || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                        Billing Address 2<br />
							<Input
								type="text"
								name="billingAddress2"
								value={this.state.subscriptionInEdit.billingAddress2 || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                        City<br />
							<Input
								type="text"
								name="city"
								value={this.state.subscriptionInEdit.city || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
                    <div className="state-wrapper">
                        <label htmlFor="State" className="">State </label>
                            <DropDownList data={this.props.common.states}
                                dataItemKey="id"
                                textField="name"
                                onChange={this.handleState}
                                value={this.state.subscriptionInEdit.state}
                                allowCustom={false}
                                filterable={false}
                                clearButton={false}
                                width={300}
                                required={true}
                            />
				    </div>
					<div>
						<label>
                        Zip<br />
							<Input
								pattern="(\d{5}([\-]\d{4})?)"
								type="text"
								placeholder="12345"
								title="Zip Code (Format: 12345 or 12345-6789)"
								name="zip"
								value={this.state.subscriptionInEdit.zip || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
                    <DialogActionsBar>
						<button className="admin-k-button" onClick={this.props.cancel}>
							<i className="fas fa-times"></i>
							<span>CANCEL</span>
						</button>
                        <button type="submit" className="admin-k-button">
                            UPDATE
                        </button>
					</DialogActionsBar>
                </form>
            </Dialog>
        )
    }
}

function mapStateToProps(state){
    return{
        subscription: state.adminSubscription.subscriptions[0],
		common: state.common,
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchSubscriptions,
    updateSubscription,
    checkAddressCall,
}) (AddressValidationTest);
